import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=62fbd3b7&scoped=true"
import script from "./workDetail.vue?vue&type=script&lang=js"
export * from "./workDetail.vue?vue&type=script&lang=js"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=62fbd3b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbd3b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fbd3b7')) {
      api.createRecord('62fbd3b7', component.options)
    } else {
      api.reload('62fbd3b7', component.options)
    }
    module.hot.accept("./workDetail.vue?vue&type=template&id=62fbd3b7&scoped=true", function () {
      api.rerender('62fbd3b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/workTotal/workDetail.vue"
export default component.exports